/**
 * マニフェスト管理
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/managements/registrations`


const manifest_management_registration = {

  namespaced: true,
  actions: {
    create ({ commit }, { params }) {
      return new Promise( ( resolve, reject ) => {
        Vue.$http.post(API_PATH, params, { headers: { 'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('freelySnackbar/showInfo', {
            title: '登録しました',
            subTitle: 'DXEマニ番号',
            messages: [content.manifest_id],
            enableCopy: true,
            timeout: 6000,
          }, { root: true })
          resolve(content)
        // }).catch(error => {
        //   reject(error)
        } )
      })
    },
    /**
     * マニフェストの更新
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve, reject ) => {
        const api_path = `${API_PATH}/${id}`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        // }).catch(error => {
        //   reject(error)
        } );
      })
    },
  },
}

export default manifest_management_registration
